import axios, { AxiosRequestConfig } from "axios";
import Cookies from "js-cookie";
import { endpoints } from "../env";
import { deviceInfoCache } from "./deviceInfoCache";
import { XClientSystem } from "@inhouse-market/sdk";

const api = axios.create({
  baseURL: endpoints.api,
});

api.interceptors.request.use(async (config: AxiosRequestConfig) => {
  config.headers = config.headers || {};
  const headers = config.headers;

  headers['x-app-version'] = process.env.VERSION || '';
  headers['x-platform'] = "web";
  headers['x-device-id'] = deviceInfoCache() || '';
  headers['x-user-id'] = Cookies.get('userId') || '';
  headers['x-client-system'] = XClientSystem.PWA

  return config;
});

export default api;